// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"18ceaa07","977":"7624cc56"}[chunkId] + ".chunk.js";
};